import styled from '@emotion/styled';
import { StyledTagItem } from '~/shared/components/TagItem/styled';
import { TagItem } from '~/shared/components/TagItem/TagItem';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';
import { ISelectedFacetsTagList } from '../models/M170ProductFilter';

const StyledList = styled.div({
	marginTop: '20px',
	marginBottom: '20px',
});

const StyledListContent = styled.ul({
	display: 'flex',
	flexWrap: 'wrap',
	margin: '-5px',

	[`${StyledTagItem}`]: {
		margin: '5px',
	},
});

export const SelectedFacetsTagList = ({ facetValues, onFacetClick, onRemoveAllClick }: ISelectedFacetsTagList) => {
	const { translate } = useTranslation();

	return (
		<StyledList>
			<StyledListContent>
				{facetValues.map((facetValue) => (
					<TagItem
						key={`${facetValue.facetId}-${facetValue.id}`}
						label={facetValue.label}
						onClick={() => onFacetClick(facetValue.facetId, facetValue.id, true)}
					/>
				))}
				<TagItem
					plain={true}
					label={translate('filter.clear-all')}
					onClick={onRemoveAllClick}
				/>
			</StyledListContent>
		</StyledList>
	);
};
